/**
 * A CSS time value read off an element, in milliseconds. Lets a component keep
 * an element mounted for exactly as long as its exit animation runs without
 * repeating the duration in JS, where the two would drift.
 *
 * An unreadable value — no stylesheet, as in a test — means there is no
 * animation to wait for.
 */
export function readCssDurationMs(
  element: HTMLElement | null,
  property: string,
) {
  if (!element) return 0;

  const value = getComputedStyle(element).getPropertyValue(property).trim();

  if (value.endsWith('ms')) return Number.parseFloat(value);
  if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
  return 0;
}
